import { Box, Typography } from "@mui/material";

export interface FilterItem {
  label: string;
}

export interface FilterBarProps {
  filters: FilterItem[];
  className?: string;
}

export const FilterBar = ({ filters, className }: FilterBarProps) => {
  if (!filters || filters.length === 0) {
    return null;
  }

  const filterText = filters.map((filter) => filter.label).join(" • ");

  return (
    <Box
      className={className}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        paddingTop: { mobile: 0, desktop: 200 },
      }}
    >
      <Typography variant="bodySmall" maxWidth="40em">
        {filterText}
      </Typography>
    </Box>
  );
};
